
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/results-driven",
      function () {
        return require("private-next-pages/results-driven.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/results-driven"])
      });
    }
  